import React, { memo } from 'react';
import { ChatCardTypeTokens, } from '@voltmoney/schema';
import SenderChatCardBase from './SenderChatCard.base';
import ReceiverChatCardBase from './ReceiverChatCard.base';
import ReplyChatCardBase from './ReplyChatCard.base';
import ThemeProvider from '@voltmoney/theme';
/**
 * Primary UI component for user interaction
 */
const ChatCard = ({ type, ...props }) => {
    /**
     *  logic -> base-component(...props)
     * */
    const theme = ThemeProvider.getTheme();
    const chatCardThemeProps = theme.chatCard[type];
    switch (type) {
        case ChatCardTypeTokens.sender:
            return (React.createElement(SenderChatCardBase, { ...chatCardThemeProps, ...props }));
        case ChatCardTypeTokens.receiver:
            return (React.createElement(ReceiverChatCardBase, { ...chatCardThemeProps, ...props }));
        case ChatCardTypeTokens.reply:
            return (React.createElement(ReplyChatCardBase, { ...chatCardThemeProps, ...props }));
        default:
            return React.createElement(React.Fragment, null);
    }
};
export default memo(ChatCard);
export { ChatCard };
